import { fetchProlongationOrders } from '../api';
import { ordersHistoryEmptyMessages } from '../config';
import { prepareOrdersProlongationList } from './orders-prolonglation-list';
import { Env } from '@/shared/config/environment';

const state = {
  ordersList: [],
  ordersProlongationList: null,
  isLoadingOrders: false,
  ordersError: null,
};

const mutations = {
  SET_ORDERS_LIST(state, ordersList) {
    state.ordersList = ordersList;
  },
  SET_LOADING_ORDERS(state, isLoading) {
    state.isLoadingOrders = isLoading;
  },
  SET_ORDERS_ERROR(state, error) {
    state.ordersError = error;
  },
  SET_ORDERS_PROLONGATION_LIST(state, ordersProlongationList) {
    state.ordersProlongationList = ordersProlongationList;
  },
};

const actions = {
  async fetchOrdersList({ commit, dispatch }) {
    commit('SET_LOADING_ORDERS', true);
    commit('SET_ORDERS_ERROR', null);
    commit('SET_ORDERS_LIST', []);

    try {
      const orders = await fetchProlongationOrders();
      commit('SET_ORDERS_LIST', orders);

      const prolongationList = prepareOrdersProlongationList(orders);
      commit('SET_ORDERS_PROLONGATION_LIST', prolongationList);
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити дані про замовлення';

      commit('SET_ORDERS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити дані про замовлення',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_ORDERS', false);
    }
  },
};

const getters = {
  isLoadingOrders: (state) => state.isLoadingOrders,
  ordersError: (state) => state.ordersError,
  isOrdersDataReady: (state) => state.isLoadingOrders === false && state.ordersProlongationList !== null && state.sales !== null,
  isEmpty: (state) => state?.ordersProlongationList?.length === 0,
  getEmptyMessage: () => ordersHistoryEmptyMessages[0],
  getOrdersProlongationList: (state) => state.ordersProlongationList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
